export const dateColumnNames = [
    'measurement_date',
    'date_adjusted',
    'prepayment_date',
    'repayment_date',
    'delivery_date',
    'mount_date',
    'delivery_date',
    'initial_delivery_date',
    'shipment_date',
    'date_close_complaint',
    'date_application',
]